import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Heart, Loader2 } from "lucide-react";
import api from "@/lib/api";
import { ProductCard } from "@/components/ProductCard";
import { Footer } from "@/components/Footer";

export default function Favourites() {
  const [products, setProducts] = useState(null);
  useEffect(() => { api.get("/favourites").then((r) => setProducts(r.data)); }, []);

  if (!products) return <div className="min-h-[60vh] flex items-center justify-center"><Loader2 className="animate-spin text-[#1A3C2A]" /></div>;

  return (
    <div className="max-w-6xl mx-auto px-4 sm:px-6 py-6 sm:py-10 min-h-[70vh]">
      <h1 className="font-display text-2xl sm:text-3xl font-bold text-[#1A3C2A] mb-6 flex items-center gap-2"><Heart className="fill-[#E07A5F] text-[#E07A5F]" /> Favourites</h1>
      {products.length === 0 ? (
        <div className="text-center py-20">
          <p className="font-display text-xl font-bold text-[#1A3C2A]">No favourites yet</p>
          <Link to="/browse" className="text-sm font-semibold text-[#E07A5F] mt-1 inline-block">Browse products</Link>
        </div>
      ) : (
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 sm:gap-5">
          {products.map((p, i) => <ProductCard key={p.id} product={p} index={i} />)}
        </div>
      )}
      <div className="mt-16"><Footer /></div>
    </div>
  );
}
